import angular from 'angular';
import cmsAuth from '../Auth/CMSAuthService'

/**
 * @param CMSAuthService
 * @returns {aclService}
 */
let aclService = function(CMSAuthService) {

    /**
     * Allow (true) when:
     * - empty roles param
     * - user has at least one role matching roles param
     *
     * Disallow (false) when:
     * - user not logged (!user)
     * - user roles empty
     * - user has none of requested roles param
     *
     * @param roles
     * @returns boolean
     */
    this.matchRoles = function(roles) {

        if(!roles) {
            return true;
        }

        let user = CMSAuthService.getUser();
        if(!user || !user.roles) {
            return false;
        }

        let allowed = user.roles.some((el) => {
            return roles.indexOf(el) !== -1;
        });

        return allowed;

    };
    return this;

};

/**
 * @namespace cms.acl
 */
export default angular.module('cms.acl.service', [cmsAuth]).factory('ACLService', aclService).name;




// WEBPACK FOOTER //
// ./src/cmsCore/ACL/ACLService.js